<template>
  <div>
    <a class="uk-margin-small-right" type="button" @click="toggleOverlay"
      ><menu-icon class="mobile-menu-icon"
    /></a>

    <div
      id="offcanvas-nav-primary"
      ref="offcanvasNavPrimary"
      class="dropdown-menu"
    >
      <div class="mobile-nav">
        <!-- :to="{ path: item.fields.title === 'Work' ? '/work' : item.fields.link }" -->
        <template v-for="item in data">
          <a
            v-if="item.fields.externalLink"
            :href="item.fields.link"
            rel="nofollow"
            target="_blank"
            class="mobile-nav__item"
            :class="['uk-h2', item.fields.colour.fields.colourSlug]"
          >
            <div>
              <h3 :class="['uk-h2', item.fields.colour.fields.colourSlug]">{{
                item.fields.title
              }}</h3>
            </div>
          </a>

          <a
            v-else-if="
              ['/#top', '/#about', '/#contact-me'].includes(item.fields.link)
            "
            @click="onLinkClick(item.fields.link.substr(2))"
            class="mobile-nav__item"
            :class="['uk-h2', item.fields.colour.fields.colourSlug]"
          >
            <div>
              <h3 :class="['uk-h2', item.fields.colour.fields.colourSlug]">{{
                item.fields.title
              }}</h3>
            </div>
          </a>

          <router-link
            v-else
            :key="item.sys.id"
            :to="item.fields.link"
            class="mobile-nav__item"
          >
            <div>
              <h3 :class="['uk-h2', item.fields.colour.fields.colourSlug]">{{
                item.fields.title
              }}</h3>
            </div>
          </router-link>
        </template>
        <router-link :to="{ path: home.link }" class="mobile-nav__item">
          <div>
            <h3 :class="['uk-h2', home.color]">{{ home.title }}</h3>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import menuIcon from '@/assets/img/menu.svg'
import InstagramLogo from '@/assets/img/white-instagram.svg'
export default {
  props: ['data'],
  data() {
    return {
      home: {
        title: 'Home',
        link: '/',
        color: 'purple',
      },
    }
  },
  components: {
    menuIcon,
  },

  methods: {
    toggleOverlay() {
      let dropdown = this.$refs.offcanvasNavPrimary
      let overlay = document.querySelector('[data-overlay]')
      let body = document.querySelector('body')
      if (body.classList.contains('scroll-lock')) {
        dropdown.classList.remove('active')
        overlay.classList.remove('active')
        body.classList.remove('scroll-lock')
      } else {
        dropdown.classList.add('active')
        overlay.classList.add('active')
        body.classList.add('scroll-lock')
      }
    },
    onLinkClick(link) {
      this.$router.push(`/#${link}`)
      this.$root.$emit('linkClick', link)
      this.toggleOverlay()
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile-menu-icon {
  width: 2rem;
  height: 2rem;
  fill: white;
  transition: $transition;
  &:focus {
    fill: $purple;
    transition: $transition;
  }
}
.dropdown-menu {
  position: absolute;
  top: 5rem;
  left: 0;
  width: 100%;
  // height: 100%;
  height: calc(100vh - 5rem);
  overflow-y: scroll;
  // background-color: rgba(black, .9);
  z-index: -1;
  transform: translateY(-100%);
  opacity: 0;
  visibility: hidden;
  transition: 0.4s ease-in-out;

  display: flex;
  align-items: center;
  justify-content: center;

  &.active {
    opacity: 1;
    visibility: visible;
    transition: 0.4s ease-in-out;
    transform: translateY(0%);
  }
}

.mobile-nav {
  width: 100%;
  height: 100%;
  padding: 0.75rem 25px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  &__item {
    width: 100%;
    margin-bottom: 14px;
    padding: 6px;
    background: $black;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;

    @include mq($until: desktop, $and: '(orientation: landscape)') {
      width: calc(33% - 12px);
      margin: 6px;
    }

    h3 {
      font-size: 3.4rem;
      line-height: 1;
      margin-bottom: 0;
      @include mq($until: desktop, $and: '(orientation: landscape)') {
        font-size: 2rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MobileNav.vue